import { BehaviorSubject } from 'rxjs';
import { DEMO_MODE_STORAGE_KEY } from './demo-mode.constants';
import * as i0 from "@angular/core";
var DemoModeService = /** @class */ (function () {
    function DemoModeService() {
        this.demoModeSubject = new BehaviorSubject(this.readFromStorage());
        this.demoMode$ = this.demoModeSubject.asObservable();
    }
    DemoModeService.prototype.isDemoMode = function () {
        return this.demoModeSubject.value;
    };
    DemoModeService.prototype.setDemoMode = function (enabled) {
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem(DEMO_MODE_STORAGE_KEY, enabled ? 'true' : 'false');
        }
        this.demoModeSubject.next(enabled);
    };
    DemoModeService.prototype.readFromStorage = function () {
        if (typeof window === 'undefined' || !window.localStorage) {
            return false;
        }
        return window.localStorage.getItem(DEMO_MODE_STORAGE_KEY) === 'true';
    };
    DemoModeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DemoModeService_Factory() { return new DemoModeService(); }, token: DemoModeService, providedIn: "root" });
    return DemoModeService;
}());
export { DemoModeService };
